import { createContext } from "react";

const DF_LO0025Context = createContext();

export { DF_LO0025Context };